import Breadcrumb from "components/Common/Breadcrumb";
import React, { useEffect, useMemo, useState } from "react";
import {  Card, CardBody, Col, Label, Row } from "reactstrap";
import "moment/locale/en-gb";
import moment from "moment-timezone";
import "moment-timezone";
import DatePicker from "react-datepicker";
// import { Input, DatePicker, Calendar } from 'rsuite';
import "react-datepicker/dist/react-datepicker.css";
import { AdminService } from "services/AdminService";
import TableContainer from "components/Common/TableContainer";
import { Report } from "models/Report";

// import DriverInvoiceView from "./DriverInvoiceView";
import { toast } from "react-toastify";
toast.configure();
import "react-toastify/dist/ReactToastify.css";
import { Puff } from "react-loader-spinner";

interface ReportSum {
  driverValue: number | null;
  totalOrderValue: number | null;
  tax: number | null;
  revenue: number | null;
}

const CustomerReports: React.FC = () => {
  const [startDate, setStartDate] = useState(moment.tz("America/Toronto").startOf("month"));
  const [endDate, setEndDate] = useState(moment.tz("America/Toronto"));

  const [showTable, setShowTable] = useState(false);
  const [orderReport, setOrderReport] = useState([] as Report[]);
  const [isloading, setIsloading] = useState<boolean>(true);
  const [searchText, setSearchText] = useState("");
    const [orderReportsum, setOrderReportsum] = useState([] as ReportSum[]);
  // const [isOffset_p_c, setOffset_p_c] = useState<number>(1);
  const [LIMIT_P_C, setLIMIT_P_C] = useState<number>(10);
  const [pageCount, setPageCount] = useState<number>(1);

  const data = {
    date1: startDate,
    date2: endDate,
  };

  useEffect(() => {
    setIsloading(true);
    AdminService.getCustomerReport(data)
      .then(res => {
        if (res.success) {
          console.log("res",res.data.customerReport)
          setOrderReport(res.data.customerReport);
          setPageCount(Math.ceil(res.data.count / LIMIT_P_C));
        }
      })
      .catch(error => {
        console.error(error);
      });
    setIsloading(false);
  }, [showTable]);

//  const calculateTotals = (
//   reports: ReportSum[]
// ): { totalOrders: number; totalAmount: number; tax: number; revenue: number } => {
//   return reports.reduce(
//     (acc, orderReport) => {
//       acc.totalOrders += orderReport.totalOrders ?? 0;
//       acc.totalAmount += orderReport.totalOrderValue ?? 0;
//       acc.tax += orderReport.tax ?? 0;
//       acc.revenue +=orderReport.revenue ?? 0;
//       return acc;
//     },
//     { totalOrders: 0, totalAmount: 0, tax: 0, revenue: 0 }
//   );
// };
const calculateTotals = (reports: ReportSum[]) => {
  return reports.reduce(
    (acc: { totalOrderValue: number; driverValue: number; tax: number; revenue: number }, report) => {
      acc.totalOrderValue += Number(report.totalOrderValue ?? 0);
      acc.tax += Number(report.tax ?? 0);
      acc.driverValue += Number(report.driverValue ?? 0);
      acc.revenue += Number(report.revenue ?? 0);
      return acc;
    },
    {
      totalOrderValue: 0,
      driverValue: 0,
      tax: 0,
      revenue: 0,
    }
  );
};



  const searchTable = (searchText: string) => {
    setSearchText(searchText);
    // setOffset_p_c(1);  
    const searchData = searchText.trim()
      ? { date1: startDate, date2: endDate, searchableString: searchText }
      : { date1: startDate, date2: endDate };
  
    const fetchFunction = searchText.trim()
      ? AdminService.getCustomerReportBySearch(searchData, LIMIT_P_C, 1)
      : AdminService.getCustomerReport(searchData, LIMIT_P_C, 1);
  
    fetchFunction
      .then(res => {
        if (res.success) {
          setOrderReport(res.data.customerReport);
          setPageCount(Math.ceil(res.data.count / LIMIT_P_C));
        } else {
          setOrderReport([]);
          setPageCount(1);
        }
      })
      .catch(error => {
        console.error(error);
        toast.error("Search failed. Please try again.");
      });
  };
  

  
  const handleStartDate = (date: Date | null) => {
    const sDate = moment(date);
    setStartDate(sDate);
  };

  const handleEndDate = (date: Date | null) => {
    const eDate = moment(date);
    setEndDate(eDate);
  };


    const exportToCsv = (data: Report[], fileName: string) => {
      if (!data || !data.length) {
        alert("No data available to export.");
        return;
      }
  
  
      const headers = Object.keys(data[0]);
  
  
      const csvContent =
        [headers.join(",")] + 
        "\n" +
        data
          .map(row =>
            headers
              .map(
                fieldName => JSON.stringify((row as Record<string, unknown>)[fieldName]?? "") 
              )
              .join(",")
          )
          .join("\n");
  
    
      const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
      const url = URL.createObjectURL(blob);
  
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `${fileName}.csv`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    };
  // const generateInvoice = () => {
  //   AdminService.sendDriverBillingInvoices(data)
  //     .then(res => {
  //       if (res.success) {
  //         setDriverBills(res.data);
  //         toast.success("Successfully generated invoices.", {
  //           position: toast.POSITION.BOTTOM_RIGHT,
  //           className: "foo-bar",
  //           style: { marginBottom: "4rem" },
  //         });
  //       } else {
  //         toast.info("There are no pending driver billing invoices.", {
  //           position: toast.POSITION.BOTTOM_RIGHT,
  //           className: "foo-bar",
  //           style: { marginBottom: "4rem" },
  //         });
  //       }
  //     })
  //     .catch(error => {
  //       console.error(error);
  //     });
  // };




  const SeeMore = (page: { selected: number }) => {
    // setOffset_p_c(page.selected + 1);
  
    if (searchText.trim() !== "") {
      const searchData = {
        date1: startDate,
        date2: endDate,
        searchableString: searchText,
      };
  
      AdminService.getCustomerReportBySearch(searchData, LIMIT_P_C, page.selected + 1)
        .then(res => {
          if (res.success) {
            setOrderReport(res.data.customerReport);
            setPageCount(Math.ceil(res.data.count / LIMIT_P_C));
          } else {
            setOrderReport([]);
            setPageCount(1);
          }
        })
        .catch(error => {
          console.error(error);
          toast.error("Failed to fetch search results.");
        });
  
    } else {
      AdminService.getCustomerReport(data, LIMIT_P_C, page.selected + 1)
        .then(res => {
          if (res.success) {
            setOrderReport(res.data.customerReport);
            setPageCount(Math.ceil(res.data.count / LIMIT_P_C));
          } else {
            setOrderReport([]);
            setPageCount(1);
          }
        })
        .catch(error => {
          console.error(error);
          toast.error("Failed to fetch data.");
        });
    }
  };
  
  


     const handleColumnChange = (selectedOption: any) => {
        setLIMIT_P_C(selectedOption.value);
        AdminService.getCustomerReport(data, selectedOption.value, 1).then(res => {
          if (res.success) {
            setOrderReport(res.data.customerReport);
            setPageCount(Math.ceil(res.data.count / selectedOption.value));
          }
        });
      };

  const columns = useMemo(
    () => [
      {
        id: "customerId",
        Header: "Customer ID",
        accessor: "customerId",
      },
      {
        id: "customerName",
        Header: "Customer Name",
        accessor: "customerName",
      },
      {
        id: "customerEmail",
        Header: "Customer Email",
        accessor: "customerEmail",
      },
      {
        id: "phoneNumber",
        Header: " Phone",
        accessor: "phoneNumber",
      },
      {
        id: "customerCreatedAt",
        Header: " Created Date",
        accessor: "customerCreatedAt",
        Cell: ({ value }: { value: string }) => {
          return moment(value).format("YYYY-MM-DD");
        },
      },
      {
        id: "totalOrders",
        Header: "Total Number of Orders",
        accessor: "totalOrders",
      },
      {
        id: "totalAmount",
        Header: "Total Order Value",
        accessor: "totalOrderValue",
        Cell: ({ value }: { value: number | null }) => (value !== undefined && value !== null ? value.toFixed(2) : "N/A"),
      },
      {
        id: "tax",
        Header: "Tax",
        accessor: "tax",
        Cell: ({ value }: { value: number | null }) => (value !== undefined && value !== null ? value.toFixed(2) : "N/A"),
      },
      {
        id: "driverValue",
        Header: "Driver Value",
        accessor: "driverValue",
        Cell: ({ value }: { value: number | null }) => (value !== undefined && value !== null ? value.toFixed(2) : "N/A"),
      },
      {
        id: "revenue",
        Header: "Revenue",
        accessor: "revenue",
        Cell: ({ value }: { value: number | null }) => (value !== undefined && value !== null ? value.toFixed(2) : "N/A"),
      },
    ],
    []
  );

const totals = calculateTotals(
  orderReport.map(report => ({
    totalOrderValue: (report as any).totalOrderValue ?? 0,
    tax: (report as any).tax ?? 0,
    driverValue: (report as any).driverValue ?? 0,
    revenue: (report as any).revenue ?? 0,
  }))
);



  document.title = "Customer Reports | Zulu Courier";

  return (
    <React.Fragment>
      <div className="page-content mb-5">
        <div className="container-fluid mb-5">
          <Breadcrumb title="Customer Reports" breadcrumbItem="Customer Reports" />
          <Row>
            <Col lg="12">
              <Card className="mb-5 bg-m-none">
                <CardBody>
                  <div className="wizard clearfix mb-5">
                    <Label>Date Selection</Label>
                    <Row>
                      <Col lg="4" className="h-100">
                        <DatePicker
                          onFocus={e => e.target.blur()}
                          selected={startDate ? startDate.toDate() : null}
                          onChange={handleStartDate}
 
                          dateFormat="yyyy-MM-dd"
                     
                          className="form-control mb-2"
                        />
                      </Col>
                      <Col lg="1" className="text-center">
                        <Label className="mt-lg-2">To</Label>
                      </Col>
                      <Col lg="4">
                        <DatePicker
                          onFocus={e => e.target.blur()}
                          selected={endDate ? endDate.toDate() : null}
                          onChange={handleEndDate}
                          dateFormat="yyyy-MM-dd"
                          className="form-control mb-2"
                        />
                      </Col>
                      <Col lg="1">
                        <button type="submit" onClick={() => setShowTable(!showTable)} className="btn btn-primary btn-sm px-3 me-2 mt-lg-2">
                          Filter
                        </button>
                        {/* <button type="submit" onClick={generateInvoice} className="btn btn-primary btn-sm mt-lg-2">
                          Generate Invoice
                        </button> */}
                      </Col>

                      {/* <Col lg="1" className="text-right">
                      <button className="btn btn-primary btn-sm px-3 me-2 mt-lg-2" onClick={() => exportToCsv(orderReport, "Filtered_Report")}>
                      Export CSV
                      </button>
                     </Col> */}
                     
                     <Col lg="2" className="text-right">
                          <button className="btn btn-primary btn-sm px-3 me-2 mt-2 mt-lg-2 " onClick={() => exportToCsv(orderReport, "Filtered_Report")}>
                            Export CSV
                          </button>
                      </Col>
                    </Row>
                  </div>

                  <div className="wizard clearfix">
                    <Label>Customer Reports</Label>
                    <Row>
                      <Col lg="12">
                        {isloading ? (
                          <div className="d-flex justify-content-center align-items-center" style={{ height: "500px" }}>
                            <Puff color="#FFD0B8" height={50} width={50} />
                          </div>
                        ) : (
                          <>
                            {orderReport !== undefined && orderReport.length > 0 ? (
                              <TableContainer
                                columns={columns}
                                data={orderReport}
                                currentPage={undefined}
                                pagelimit={pageCount}
                                handlePageChange={SeeMore}
                                handleColumnChange={handleColumnChange}
                                selectedColumns={LIMIT_P_C}
                                showColumnChange={true}
                                handleSearch={searchTable}
                                isGlobalFilter={true}
                                isAddOptions={false}
                                customPageSize={50}
                                className="custom-header-css"
                                isJobListGlobalFilter={undefined}
                                isAddUserList={undefined}
                                handleOrderClicks={undefined}
                                handleUserClick={undefined}
                                handleCustomerClick={undefined}
                                isAddCustList={undefined}
                                handleSendEmail={undefined}
                                isPDFGenerate={false}
                                ispopup={false}
                                isAddressBook={false}
                                hancleDeleteRecords={undefined}
                                handleSelect={undefined}
                                selectedID={undefined}
                                hasCheckBox={false}
                                 footerData={[
                                  {
                                    totalAmount: totals.totalOrderValue.toFixed(2),
                                    tax: totals.tax.toFixed(2),
                                    driverValue: totals.driverValue.toFixed(2),
                                    revenue: totals.revenue.toFixed(2),
                                  },
                                ]}
                              />
                            ) : (
                              <Row className="justify-content-md-center justify-content-center align-items-center mb-5">
                                <Col className="col-md-auto">
                                  <div>No Customer Report</div>
                                </Col>
                              </Row>
                            )}
                          </>
                        )}
                      </Col>
                    </Row>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>

          {/* <DriverInvoiceView isOpen={modal} handlePopup={handlePopup} driverBill={driverBill} dates={data} /> */}
        </div>
      </div>
    </React.Fragment>
  );
};

export default CustomerReports;
